export const FEATURE_NAME = 'layout'

export const LAYOUT_ID = 'sw-layout'
